import { earchiveLiteApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  earchiveLiteApi.get<ProductInfoResponse>('/api/v1/productInfo', config);

export const updateProductDescription = (description: string) =>
  earchiveLiteApi.patch<void>('/api/v1/productInfo', { description });
